import { EngineUtils } from '../services/EngineUtils.js';
export class ObjectHashSet {
    constructor() {
        this.primitiveSet = new Set();
        this.referenceSet = new Map();
    }
    add(value) {
        if (primitiveTypeGuard(value)) {
            this.primitiveSet.add(value);
        }
        else {
            this.referenceSet.set(EngineUtils.hash(value), value);
        }
    }
    has(value) {
        if (primitiveTypeGuard(value)) {
            return this.primitiveSet.has(value);
        }
        else {
            return this.referenceSet.has(EngineUtils.hash(value));
        }
    }
    delete(value) {
        if (primitiveTypeGuard(value)) {
            this.primitiveSet.delete(value);
        }
        else {
            this.referenceSet.delete(EngineUtils.hash(value));
        }
    }
    toArray() {
        const primitives = Array.from(this.primitiveSet);
        const referenceValues = Array.from(this.referenceSet.values());
        return primitives.concat(referenceValues);
    }
}
function primitiveTypeGuard(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}
//# sourceMappingURL=ObjectHashSet.js.map